import { get, post } from "./api";

const OM_PREFIX = "/orange";

export const lancerPaiementOM = async (payload) => {
  try {
    const res = await post(`${OM_PREFIX}/getWebPaiement`, payload);
    return res.data;
  } catch (err) {
    console.error("Erreur paiement OM :", err);
    return { status: 500, message: "Erreur OM" };
  }
};

export const verifierStatusPaiement = async (id) => {
  try {
    const res = await get(`${OM_PREFIX}/checkPaiementBooking/${id}`);
    return res.data;
  } catch (err) {
    console.error("Erreur statut paiement OM :", err);
    return { status: 500 };
  }
};


export const checkStatusPay = async (data) => {
  try {
    const res = await post(`${OM_PREFIX}/checkStatusPay`, data);
    return res.data;
  } catch (err) {
    console.error("Erreur checkStatusPay :", err);
    return { status: 500 };
  }
};
